import type { NextRouter } from 'next/router'
import {
  EnterpriseCartEvents,
  segment,
  trackGoldStandardEvent,
} from '@mc/track-event'
import { hasActiveAnnualMembership } from '@mc/user-info'
import { paths } from '@mc/paths'
import { getPageSourceFromPath } from './pathHelpers'

export const trackContactSales = () => {
  trackGoldStandardEvent(EnterpriseCartEvents.EVENTS.CONTACT_SALES, {
    position: 'navigation',
  })
}

export const trackMAWLogoClick =
  ({
    logoUrl,
    pathname,
    query,
  }: { logoUrl: string } & Pick<NextRouter, 'pathname' | 'query'>) =>
  () => {
    const action = logoUrl === paths.enterpriseHomepage ? 'MAW Home' : 'Home'
    trackGoldStandardEvent(segment.NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
      action,
      page_source: getPageSourceFromPath({ pathname, query }),
      post_paywall: hasActiveAnnualMembership(),
      level: segment.NavigationEvents.LEVELS.PRIMARY,
    })
  }

export const trackBrowseSkillsCatalogCTAClick =
  ({
    action,
    pathname,
    query,
    level = segment.NavigationEvents.LEVELS.PRIMARY,
  }: { action: string; level: string } & Pick<
    NextRouter,
    'pathname' | 'query'
  >) =>
  () => {
    trackGoldStandardEvent(segment.NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
      action,
      page_source: getPageSourceFromPath({ pathname, query }),
      post_paywall: hasActiveAnnualMembership(),
      level,
    })
  }

export const trackSolutionsClick = ({
  action,
  pathname,
  query,
}: { action: string } & Pick<NextRouter, 'pathname' | 'query'>) => {
  trackGoldStandardEvent(segment.NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    action,
    page_source: getPageSourceFromPath({ pathname, query }),
    post_paywall: hasActiveAnnualMembership(),
    level: segment.NavigationEvents.LEVELS.PRIMARY,
  })
}

export const trackSolutionsItemClick = ({
  action,
  pathname,
  query,
}: { action: string } & Pick<NextRouter, 'pathname' | 'query'>) => {
  trackGoldStandardEvent(segment.NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    action,
    page_source: getPageSourceFromPath({ pathname, query }),
    post_paywall: hasActiveAnnualMembership(),
    level: segment.NavigationEvents.LEVELS.SECONDARY,
  })
}
